import { motion } from "framer-motion";
import { Fern } from "@/components/site/BrandMark";
import { renderScriptTitle } from "@/components/site/scriptTitle";

const NUMS = ["01", "02", "03"];

const DEFAULT_CARDS = [
  { title: "Compreender", text: "Identificar pensamentos, emoções e padrões de comportamento que influenciam suas experiências." },
  { title: "Desenvolver", text: "Construir estratégias práticas para enfrentar dificuldades e lidar com as emoções." },
  { title: "Transformar", text: "Aplicar novos aprendizados no cotidiano, fortalecendo autonomia e bem-estar." },
];

export default function Approach({ content }) {
  const kicker = content?.approach_kicker || "Abordagem terapêutica";
  const title = content?.approach_title || "Terapia *Cognitivo-Comportamental* (TCC)";
  const intro = content?.approach_intro || "Uma abordagem que ajuda você a compreender a relação entre pensamentos, emoções e comportamentos, desenvolvendo novas formas de lidar com os desafios do dia a dia.";
  const cards = Array.isArray(content?.approach_cards) && content.approach_cards.length === 3
    ? content.approach_cards : DEFAULT_CARDS;

  return (
    <section id="abordagem" className="relative bg-[#2C332A] py-24 sm:py-32 overflow-hidden" data-testid="approach-section">
      <Fern color="#8A9A82" opacity={0.1} className="pointer-events-none absolute -right-10 top-0 w-[360px]" />
      <Fern color="#8A9A82" opacity={0.08} className="pointer-events-none absolute -left-16 bottom-0 w-[300px] scale-x-[-1]" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <span className="font-body text-xs tracking-[0.4em] uppercase text-[#C87A5E]">{kicker}</span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl text-[#FDFBF7] leading-tight text-balance">
            {renderScriptTitle(title, "font-script text-[#C8A98E] text-5xl sm:text-6xl")}
          </h2>
          <p className="mt-5 font-body text-[#C7CFC2] leading-relaxed max-w-xl">
            {intro}
          </p>
        </motion.div>

        <div className="mt-12 grid gap-px sm:grid-cols-3 rounded-3xl overflow-hidden border border-[#FDFBF7]/10">
          {cards.map((c, i) => (
            <motion.div
              key={NUMS[i] || i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="relative bg-[#333B31] p-9 sm:p-10 transition-colors duration-500 hover:bg-[#3B4438]"
              data-testid={`approach-chapter-${NUMS[i] || i}`}
            >
              <span className="font-display text-6xl sm:text-7xl text-[#5B6E5B]">{NUMS[i] || `0${i + 1}`}</span>
              <h3 className="mt-5 font-display text-2xl text-[#FDFBF7]">{c.title}</h3>
              <p className="mt-3 font-body text-sm text-[#C7CFC2] leading-relaxed">{c.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
